// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tEef2bysCGRcU39cEciA {
  padding-top: 20px;
}
.ant-modal .ant-modal-footer > .ant-btn + .ant-btn {
  margin-inline-start: 0 !important;
}
.ant-form-item {
  margin-bottom: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./../../ui-next/src/components/PhoneReport/components/ValidateModal/index.module.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AAGA;EAEI,iCAAA;AAFJ;AAAA;EAMI,2BAAA;AAHJ","sourcesContent":[".content{\n  padding-top:20px;\n\n}\n\n:global {\n  .ant-modal .ant-modal-footer > .ant-btn + .ant-btn {\n    margin-inline-start: 0 !important;\n  }\n\n  .ant-form-item{\n    margin-bottom: 0 !important;\n  }\n\n}\n\n@primary-color: #1DA57A;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `tEef2bysCGRcU39cEciA`
};
export default ___CSS_LOADER_EXPORT___;
